const ROUTE_VERTICAL_MAP = [
  // Service routes
  { match: (p) => p.includes("depo-provera"), value: "depoprovera" },
  { match: (p) => p.includes("toxic-baby-food"), value: "toxic-baby-food" },
  { match: (p) => p.includes("paraquat"), value: "paraquat" },
  { match: (p) => p.includes("roundup"), value: "roundup" },
  { match: (p) => p.includes("afff"), value: "afff" },
  { match: (p) => p.includes("bard-powerport") || p.includes("powerport"), value: "bard-powerport" },
  { match: (p) => p.includes("talcum"), value: "talcum powder" },
  { match: (p) => p.includes("transvaginal-mesh"), value: "hernia-mesh" },
  { match: (p) => p.includes("ultra"), value: "ultra-processed-food" },
  { match: (p) => p.includes("oxbryta"), value: "oxbryta" },
  { match: (p) => p.includes("pfas"), value: "pfas" },
];

export const getVerticalFromCurrentPath = () => {
  if (typeof window === "undefined") return null;

  const path = window.location.pathname.toLowerCase();

  for (const { match, value } of ROUTE_VERTICAL_MAP) {
    if (match(path)) return value;
  }

  return null;
};

export const LEAD_GENERATION_VERTICALS = {
  OZEMPIC: "ozempic",
  TALCUM: "talcum powder",
  DUPIXENT: "dupixent",
  DEPO_PROVERA: "depoprovera",
  HERNIA_MESH: "hernia-mesh",
  SSDI: "SSDI",
  ROBLOX: "roblox-addiction",
  RIDESHARE: "rideshare",
  HAIR_RELAXER: "hair-relaxer",
  ROUNDUP: "roundup",
  SOCIAL_MEDIA_ADDICTION: "social-media-addiction",
  MOTOR_VEHICLE_ACCIDENTS: "motor-vehicle-accidents",
  SEXUAL_ABUSE: "sexual-abuse",
  MESOTHELIOMA : 'mesothelioma',
  TOXIC_BABY_FOOD: 'toxic-baby-food',
  PARAQUAT: 'paraquat',
  AFFF: 'afff',
  ULTRA_PROCESSED_FOOD: 'ultra-processed-food',
  OXBRYTA: 'oxbryta',
  PFAS: 'pfas',
  NEC: 'nec',
  BARD_POWERPORT: 'bard-powerport',
  SUBOXONE: 'suboxone',
  TESLA_AUTOPILOT_RECALL: 'tesla-autopilot-recall',
  EIGHTEEN_WHEELER_ACCIDENT: '18-wheeler-accident'
};
